<script setup lang="ts">
/**
 * NewVersionBar — "er staat een nieuwe versie klaar, herlaad even".
 *
 * Verschijnt bovenin zodra de server een nieuwere bundel serveert dan waar
 * dit tabblad mee is opgestart (zie stores/appVersion). Bewust rustig van
 * toon en weg te klikken: er is niets kapot, en wie midden in een pagina zit
 * te schrijven moet zelf kunnen kiezen wanneer hij herlaadt.
 *
 * De tekst is Engels, ook in een Nederlandse omgeving. Dit is een bericht
 * over Pentrical zelf, net als de mails (zie het besluit van 29 augustus
 * 2026), en niet over de documentatie van de klant.
 */

import { useI18n } from 'vue-i18n'
import { RefreshCw, X } from 'lucide-vue-next'
import { useAppVersionStore } from '../../stores/appVersion'

const versie = useAppVersionStore()
const { t } = useI18n()
</script>

<template>
  <div
    v-if="versie.nieuweVersie && !versie.weggeklikt"
    class="flex items-start gap-3 px-4 py-3 sm:gap-4 sm:px-6 bg-[#C9F1FC] text-[#0B1B20]"
    role="status"
  >
    <RefreshCw class="w-6 h-6 flex-none text-[#21C4F1]" aria-hidden="true" />

    <p class="flex-1 min-w-0 text-[15px] leading-7">
      {{ t('appVersion.message') }}
      <!-- De spatie vóór de knop staat bewust in de markup: met alleen een
           marge plakt hij in een schermlezer aan het laatste woord vast. -->
      <button
        type="button"
        class="font-semibold underline underline-offset-2 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-1 focus-visible:ring-[#0B1B20] rounded"
        @click="versie.herlaad()"
      >{{ t('appVersion.reload') }}</button>
    </p>

    <button
      type="button"
      class="flex-none -my-1 -mr-2 p-2 rounded transition-opacity hover:opacity-60 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-1 focus-visible:ring-[#0B1B20]"
      :aria-label="t('appVersion.dismiss')"
      @click="versie.negeer()"
    >
      <X class="w-6 h-6" aria-hidden="true" />
    </button>
  </div>
</template>
